import React, { useState } from 'react';
import './header.css'; 
import WhitefriarLogo from '../../assets/imges/Whitefriar-logo.png';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return ( 
    <header className="">
      <div className="row mx-auto align-items-center px-lg-2 custome_container">
        {/* Logo */}
        <div className="col-6 col-lg-3 d-flex justify-content-start header-logo">
          <a href="/">
            <img src={WhitefriarLogo} className="img-fluid" alt="Logo" />
          </a>
        </div>

        {/* Start button + hamburger on mobile */}
        <div className="col-6 p-0 d-flex d-lg-none justify-content-end align-items-center">
          <a className="start-head-btn me-3" href="#solution">Start</a>
          <button
            className="hamburger-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>

        {/* Nav links - visible on desktop or toggled on mobile */}
        <div className={`mobile-nav col-12 col-lg-7 ${menuOpen ? 'open' : ''}`}>
          <ul className="list-unstyled d-flex w-100 flex-column flex-lg-row justify-content-end align-items-lg-center mt-3 mt-lg-0 mb-0">
            {['Who', 'Report', 'Deliverables', 'Process', 'Dashboard', 'Key Issues'].map((item) => {
              const hrefId = `#${item.toLowerCase().replace(/\s+/g, '-')}`; // e.g., #key-issues

              return (
                <li key={item} className="header-list px-3 py-2 py-lg-0">
                  <a href={hrefId} className="nav-links-head">{item}</a>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Start button on desktop */}
        <div className="col-lg-2 d-none d-lg-flex justify-content-end align-items-center">
          <a className="start-head-btn" href="#solution">Start</a>
        </div>
      </div>
    </header>
  );
}

export default Header;
